import { Component, Inject } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequisitoMainComponent } from './requisito-main.component';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { RequisitoService } from 'src/app/services/requisito.service';
import { Requisito } from 'src/app/models/requisito.model';

@Component({
    selector: 'app-requisito-form',
    templateUrl: './requisito-form.component.html',
    styleUrls: ['./requisito-form.component.scss']
})

export class RequisitoFormComponent {
    public keyUp = new Subject<Event>();

    basicForm: UntypedFormGroup;

    loading = false;

    constructor(protected requisitoService: RequisitoService,
                private fb: UntypedFormBuilder,
                public dialogRef: MatDialogRef<RequisitoMainComponent>,
                private toastr: ToastrComponent,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.createForm();

        const subscription = this.keyUp.pipe(
            debounceTime(250)
        ).subscribe(result => {
            this.enterSave();
        });
    }

    createForm() {        
        this.basicForm = this.fb.group({
            id: [0],
            nome: ['', Validators.required]
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    enterSave() {
        if (!this.basicForm.valid) {
            return;
        }

        this.loading = true;

        this.save();
    }

    save() {
        this.loading = true;

        const requisito: Requisito = this.basicForm.value;
        requisito.estimativaId = this.data.estimativaId;

        this.requisitoService.create(requisito).subscribe(
            () => {
                this.close();
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro incluído com sucesso');
            }, err => {
                this.toastr.mostrarMensagem('erro', 'Erro', 'Houve um problema ao salvar o registro!');
            });
    }
}
